import React from "react";
import { Button, Stack } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import {
  CustomeDialog,
  LoadingButton,
  ServerPaginatedTable,
} from "../../../shared";
import InputControl from "../../../shared/components/InputControl";
import { useRACTActiveMembers } from "../hooks";

export const ActiveMembers = () => {
  const {
    state,
    importFileRef,
    gotoPage,
    setPageSize,
    onSearchChange,
    onClearSearch,
    handleAddModal,
    onChangeMemberNumber,
    handleAddMember,
    showDeleteAlert,
    handleBulkDelete,
    openImportPicker,
    handleImport,
    handleDownloadTemplate,
    handleExport,
  } = useRACTActiveMembers();
  const { addModal } = state;

  const columns = [
    {
      Header: "Member Number",
      accessor: "member_number",
    },
    {
      Header: "Actions",
      id: "actions",
      align: "right",
      disableSortBy: true,
      accessor: (row) => row.id,
      Cell: ({ value }) => (
        <div className="action-buttons">
          <img
            alt="delete"
            src="/icons/ic_delete.svg"
            onClick={() => showDeleteAlert([value])}
          />
        </div>
      ),
    },
  ];

  return (
    <Stack spacing={1.5}>
      <ServerPaginatedTable
        columns={columns}
        data={state.members}
        isLoading={state.isLoading}
        pagination={state.pagination}
        gotoPage={gotoPage}
        setPageSize={setPageSize}
        bulkDelete
        onBulkDelete={handleBulkDelete}
        sortByGlobal={[]}
        manualSortBy={false}
        defaultSearch={false}
        filterContent={
          <Stack
            direction="row"
            flexWrap={{ xs: "wrap", sm: "nowrap" }}
            alignItems="center"
            gap="16px"
            width="100%"
            minWidth={0}
          >
            <InputControl
              type="table-search"
              name="search"
              autoComplete="off"
              value={state.searchText}
              onChange={(event) => onSearchChange(event.target.value)}
              onClear={onClearSearch}
              placeholder="Search"
              size="small"
              sx={{
                flex: { xs: "1 1 100%", sm: "1 1 0" },
                minWidth: 0,
                width: "100%",
                height: 40,
              }}
            />
            <Button
              size="small"
              onClick={handleDownloadTemplate}
              sx={{
                width: "fit-content",
                minWidth: "fit-content",
                flexShrink: 0,
              }}
            >
              Download Template
            </Button>
            <Button
              size="small"
              onClick={handleExport}
              sx={{
                width: "fit-content",
                minWidth: "fit-content",
                flexShrink: 0,
              }}
            >
              <img
                alt="export"
                src="/icons/ic_export.svg"
                style={{ marginRight: "4px", width: "20px", height: "20px" }}
              />
              Export
            </Button>
            <input
              ref={importFileRef}
              type="file"
              accept=".csv,.xlsx,.xls"
              onChange={handleImport}
              style={{ display: "none" }}
            />
            <LoadingButton
              size="small"
              loading={state.isImporting}
              onClick={openImportPicker}
              sx={{
                width: "fit-content",
                minWidth: "fit-content",
                flexShrink: 0,
              }}
            >
              <img
                alt="import"
                src="/icons/ic_Import.svg"
                style={{
                  marginRight: "4px",
                  width: "20px",
                  height: "20px",
                  filter:
                    "brightness(0) saturate(100%) invert(28%) sepia(89%) saturate(1736%) hue-rotate(205deg) brightness(92%) contrast(93%)",
                }}
              />
              Import
            </LoadingButton>
            <Button
              size="small"
              variant="outlined"
              startIcon={<AddIcon />}
              onClick={() => handleAddModal(true)}
              sx={{
                width: "fit-content",
                minWidth: "fit-content",
                flexShrink: 0,
              }}
            >
              Add New
            </Button>
          </Stack>
        }
        minWidth={560}
        completeFeature={false}
      />

      <CustomeDialog
        open={addModal.isOpen}
        handleClose={() => handleAddModal(false)}
        PaperProps={{
          sx: { width: "423px", p: "16px" },
        }}
        title="Add"
        content={
          <Stack gap="16px" pt="24px">
            <InputControl
              name="memberNumber"
              label="RACT Member Number"
              value={addModal.memberNumber}
              onChange={(event) => onChangeMemberNumber(event.target.value)}
              required
              autoFocus
            />
            <Stack direction="row" justifyContent="flex-end" gap="12px">
              <Button onClick={() => handleAddModal(false)}>Cancel</Button>
              <LoadingButton
                variant="contained"
                loading={addModal.isSaving}
                disabled={!addModal.memberNumber.trim()}
                onClick={handleAddMember}
              >
                Save
              </LoadingButton>
            </Stack>
          </Stack>
        }
      />
    </Stack>
  );
};
